import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import ReactTable from 'react-table';
import treeTableHOC from 'react-table/lib/hoc/treeTable';
import * as _ from 'lodash';

import { OrderPreferenceEnum } from 'Common/FieldEnum';
import { ORDER_PREFERENCE_OPTIONS } from 'Common/Constants';
import { caseInsensitiveFilter } from 'Common/GridHelper';

import WarehouseAndStapleForm from './WarehouseAndStapleForm';
import { HeaderLeftAlign } from 'Common/Constants/table';

const TreeTable = treeTableHOC(ReactTable);

const AssignWhKitToSiteAndSiteGroupComponent = props => {
  const {
    loadingSites,
    siteDataSource,
    siteGroupWHData,
    storageLocationData,
    selectedRowInfo,
    expanded,
    setExpandedState,
    getTdProps,
    getChildTrProps,
    onFieldChange,
    removeWarehouseKit,
  } = props;
  return (
    <Form>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column
            width={8}
            style={{ paddingLeft: 0 }}
            className="react-table-grid-mt-0"
          >
            <TreeTable
              loading={loadingSites}
              defaultPageSize={10}
              minRows={0}
              data={siteDataSource ? siteDataSource : []}
              defaultFilterMethod={caseInsensitiveFilter}
              noDataText={loadingSites ? '' : 'No sites found'}
              collapseOnDataChange={false}
              collapseOnSortingChange={false}
              getTdProps={getTdProps}
              className={'m-t-0'}
              expanded={expanded}
              onExpandedChange={expanded => setExpandedState(expanded)}
              columns={[
                {
                  columns: [
                    {
                      Header: () => <span className="ml-5">Site Group Description</span>,
                      id: OrderPreferenceEnum.Description,
                      accessor: d => d[OrderPreferenceEnum.Description],
                      width: 150,
                      ...HeaderLeftAlign,
                    },
                    {
                      Header: () => <span className="ml-5">Site Group Order Preference</span>,
                      accessor: OrderPreferenceEnum.OrderPreferenceId,
                      ...HeaderLeftAlign,
                      Cell: row => {
                        const orderPreObj = _.find(
                          ORDER_PREFERENCE_OPTIONS,
                          obj => obj.value === row.value
                        );
                        return <span>{orderPreObj.text}</span>;
                      },
                    },
                  ],
                },
              ]}
              SubComponent={rowData => {
                const row = rowData.original;
                const columns = [
                  {
                    Header: () => <span className="ml-5">Site Id</span>,
                    accessor: OrderPreferenceEnum.Id,
                    width: 120,
                    ...HeaderLeftAlign,
                  },
                  {
                    Header: () => <span className="ml-5">Site Description</span>,
                    accessor: OrderPreferenceEnum.Description,
                    ...HeaderLeftAlign,
                  },
                  {
                    Header: () => <span className="ml-5">Site Order Preference</span>,
                    accessor: OrderPreferenceEnum.OrderPreferenceId,
                    ...HeaderLeftAlign,
                    Cell: row => {
                      const orderPreObj = _.find(
                        ORDER_PREFERENCE_OPTIONS,
                        obj => obj.value === row.value
                      );
                      return <span>{orderPreObj.text}</span>;
                    },
                  },
                ];
                return (
                  <ReactTable
                    data={row[OrderPreferenceEnum.Sites]}
                    columns={columns}
                    defaultPageSize={5}
                    getTrProps={getChildTrProps}
                    style={{ marginBottom: 0 }}
                    className={'m-t-0'}
                    minRows={0}
                  />
                );
              }}
            />
          </Grid.Column>
          <Grid.Column width={8} style={{ paddingRight: 0, paddingLeft: 0 }}>
            <WarehouseAndStapleForm
              siteGroupWHData={siteGroupWHData}
              storageLocationOptions={storageLocationData}
              selectedRowInfo={selectedRowInfo}
              onFieldChange={onFieldChange}
              removeWarehouseKit={removeWarehouseKit}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

export default AssignWhKitToSiteAndSiteGroupComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignorderpreference/components/AssignWhKitToSiteAndSiteGroup.js